import { render, staticRenderFns } from "./McmForm.vue?vue&type=template&id=8422d72a&scoped=true&"
import script from "./McmForm.vue?vue&type=script&lang=ts&"
export * from "./McmForm.vue?vue&type=script&lang=ts&"
import style0 from "./McmForm.vue?vue&type=style&index=0&id=8422d72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8422d72a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDialog,VForm})
